module.exports = __webpack_public_path__ + "static/media/car-seat.31846726.svg";